
import { useSelector  } from 'react-redux';

import { getDatawin } from '../reducers'
import { getFetchGeom } from '../reducers/datawin'

export default function useDatawinFetchGeom(dataModelItemId) {
    const datawin = useSelector(state => getDatawin(state.data));
    return getFetchGeom(datawin, dataModelItemId);
}
